import { parseAllowedCountries } from "../lib/api/geo-location";

const REACT_APP_API_URL = '#{{Api_Url}}#';
const BUILD_VERSION = '#{{Build.BuildNumber}}#';
const REACT_APP_ALLOWED_COUNTRIES = '#{{Allowed_Countries}}#';

export const devMode = process.env.NODE_ENV === 'development';

export const appVersion = `${process.env.REACT_APP_VERSION}${
    BUILD_VERSION.indexOf('Build.BuildNumber') > 0 ? '' : `-${BUILD_VERSION}`
}`;

export const ALLOWED_COUNTRIES = parseAllowedCountries(REACT_APP_ALLOWED_COUNTRIES);

export const serverUrl = devMode ? process.env.REACT_APP_API_URL : REACT_APP_API_URL;
export const apiUrl = `${serverUrl}api/`;

export const microsoftClientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID || '';
export const locationApiKey = process.env.REACT_APP_LOCATION_API_KEY || '';
export const geoLocationCdnUrl = process.env.REACT_APP_GEO_LOCATION_CDN_URL || '';